import React from 'react';
import PropTypes from 'prop-types';

export default class AButtonSwitch extends React.Component {
	constructor(props) {
		super(props);

		this.state = { };

		this.bindHandles();
	}

	bindHandles() {
		this.handleSwitch = this.handleSwitch.bind(this);
	}

	handleSwitch(event) {
		const index = +event.target.getAttribute('data-index');

		this.props.onClick(index);
	}

	render() {
		return (
			<div className={`a-switch ${this.props.disabled ? 'disabled' : ''}`}>
				{
					this.props.items.map((item, index) => (
						<button
							key={item}
							className={`a-button ${this.props.index === index ? 'active' : ''}`}
							onClick={this.handleSwitch}
							disabled={this.props.disabled}
							data-index={index}
						>
							{item}
						</button>
					))
				}
			</div >
		);
	}
}

AButtonSwitch.propTypes = {
	items: PropTypes.array.isRequired,
	index: PropTypes.number,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	onClick: PropTypes.func,
};

AButtonSwitch.defaultProps = {
	index: 0,
	disabled: false,
	className: '',
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.button-switch.js